import { QuestionResponseDTO } from '@/dto/QuestionResponseDTO';

const timeToWait: number = 4000;

/**
 * A service that simulates asynchronous operations for testing purposes.
 */
class MockService {
  /**
   * Simulates an asynchronous operation to return a mock question response.
   *
   * @returns {Promise<QuestionResponseDTO>} A promise that resolves to a mock question response.
   */
  public async returnMockQuestionResponse(): Promise<QuestionResponseDTO> {
    await new Promise((resolve) => setTimeout(resolve, timeToWait));

    return {
      answer:
        'En el contexto de la adquisición de propiedades, existen diferencias significativas entre las normativas aplicables en la región de Alsacia-Mosela y el resto de Francia. En Alsacia-Mosela, se aplican reglas específicas derivadas del derecho local, que difieren en varios aspectos del derecho general francés.\n\n1. **Inscripción en el Libro Foncier**: En Alsacia-Mosela, la inscripción de la propiedad en el Libro Foncier es un requisito esencial para la validez de la adquisición de un inmueble. Esta inscripción garantiza la publicidad de los derechos de propiedad y es fundamental para la protección de los derechos de los adquirentes y terceros interesados. En el resto de Francia, la publicidad de los derechos de propiedad se realiza a través del Servicio de Publicidad Inmobiliaria, pero no tiene el mismo carácter constitutivo que en Alsacia-Mosela <referenceDoc>DT0000162594, DT0000062387</referenceDoc>.\n\n2. **Procedimientos de Ejecución Forzada**: En Alsacia-Mosela, la ejecución forzada de bienes inmuebles sigue procedimientos específicos establecidos por el derecho local. Por ejemplo, la ejecución forzada inmobiliaria solo es posible a partir del depósito de una solicitud de inscripción normalizada acompañada de los documentos justificativos necesarios. Además, existen restricciones adicionales, como la imposibilidad de ejecutar forzadamente un inmueble gravado con una prohibición de enajenar inscrita en el Libro Foncier <referenceDoc>DT0000162594</referenceDoc>.\n\n3. **Distribución de Fondos en Liquidaciones Judiciales**: En Alsacia-Mosela, la distribución de fondos en procedimientos de liquidación judicial también sigue reglas específicas. Por ejemplo, el notario solo puede iniciar el procedimiento de distribución por orden si el derecho de propiedad del adquirente está inscrito en el Libro Foncier y si ha fracasado en su misión de conciliación para una distribución amistosa de los fondos <referenceDoc>DT0000163553</referenceDoc>.\n\n4. **Mayorías en Asociaciones**: En el derecho local de Alsacia-Mosela, la constitución de asociaciones de propietarios puede realizarse con una mayoría calificada menos estricta que en el derecho general francés. Además, se presume la adhesión de los propietarios que no se oponen explícitamente a un proyecto de obras si asisten a la asamblea y no votan en contra <referenceDoc>DT0000037209</referenceDoc>.\n\nEstas diferencias reflejan la coexistencia de un régimen jurídico local específico en Alsacia-Mosela con el derecho general francés, lo que puede influir significativamente en los procedimientos y requisitos para la adquisición y gestión de propiedades en esta región.\n\n',
      sources: [
        {
          doc_id: 'DT0000162594',
          title: 'Application territoriale du droit local',
          section: null,
          documentURL:
            'https://www.lamylinenew.fr/content/document.aspx?idd=DT0000162594'
        },
        {
          doc_id: 'DT0000062387',
          title: 'Sources du droit local des sûretés réelles immobilières',
          section: null,
          documentURL:
            'https://www.lamylinenew.fr/content/document.aspx?idd=DT0000062387'
        },
        {
          doc_id: 'DT0000163553',
          title: 'Conditions légales',
          section: null,
          documentURL:
            'https://www.lamylinenew.fr/content/document.aspx?idd=DT0000163553'
        },
        {
          doc_id: 'DT0000037209',
          title: 'Régime particulier de majorité',
          section: null,
          documentURL:
            'https://www.lamylinenew.fr/content/document.aspx?idd=DT0000037209'
        }
      ]
    };
  }
}

const mockService = new MockService();
export default mockService;
